/* GLOWIVY live viewers: heartbeat every 20s, shows the real number of visitors. */
(function () {
  if (window.__liveViewersLoaded) return;
  window.__liveViewersLoaded = true;

  var INTERVAL_MS = 20000;
  var TIMEOUT_MS = 5000;
  var SESSION_KEY = 'glowivy_lv_session';

  function sessionId() {
    var id;
    try {
      id = sessionStorage.getItem(SESSION_KEY);
    } catch (e) {}
    if (!id) {
      id = window.crypto && crypto.randomUUID
        ? crypto.randomUUID()
        : 'lv-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
      try {
        sessionStorage.setItem(SESSION_KEY, id);
      } catch (e) {}
    }
    return id;
  }

  function init(el) {
    if (el.dataset.lvReady) return;
    el.dataset.lvReady = '1';

    var endpoint = (el.dataset.endpoint || '').replace(/\/+$/, '');
    var productId = el.dataset.productId;
    var min = parseInt(el.dataset.min, 10) || 2;
    var textOne = el.dataset.textOne || '[count] person is viewing this product';
    var textOther = el.dataset.textOther || '[count] people are viewing this product';
    var textEl = el.querySelector('.live-viewers__text');
    var body = JSON.stringify({ p: productId, s: sessionId() });
    var timer = null;

    // Test mode: no Worker-URL -> random numbers 10-20, only on an unpublished theme
    // (theme editor / draft preview). On the live theme the line stays hidden.
    var role = window.Shopify && Shopify.theme && Shopify.theme.role;
    var demo = !endpoint && (window.Shopify && Shopify.designMode || (role && role !== 'main'));
    var demoCount = 10 + Math.floor(Math.random() * 11);

    if (!productId || !textEl || (!endpoint && !demo)) return;

    function demoBeat() {
      demoCount = Math.min(20, Math.max(10, demoCount + Math.floor(Math.random() * 5) - 2));
      render(demoCount);
    }

    function render(count) {
      if (typeof count !== 'number' || count < min) {
        el.hidden = true;
        return;
      }
      textEl.textContent = (count === 1 ? textOne : textOther).replace(/\[count\]/g, count);
      el.hidden = false;
    }

    function beat() {
      var ctrl = window.AbortController ? new AbortController() : null;
      var t = ctrl && setTimeout(function () { ctrl.abort(); }, TIMEOUT_MS);
      fetch(endpoint + '/beat', {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: body,
        cache: 'no-store',
        credentials: 'omit',
        signal: ctrl ? ctrl.signal : undefined,
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) { render(data && data.count); })
        .catch(function () { el.hidden = true; })
        .finally(function () { if (t) clearTimeout(t); });
    }

    function start() {
      if (timer) return;
      var tick = demo ? demoBeat : beat;
      tick();
      timer = setInterval(tick, INTERVAL_MS);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function leave() {
      stop();
      if (!demo && navigator.sendBeacon) {
        navigator.sendBeacon(endpoint + '/leave', new Blob([body], { type: 'text/plain' }));
      }
    }

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') start();
      else stop();
    });
    window.addEventListener('pagehide', leave);
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && document.visibilityState === 'visible') start();
    });

    if (document.visibilityState === 'visible') start();
  }

  function initAll() {
    document.querySelectorAll('[data-live-viewers]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
